import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import PropTypes from "prop-types";

const UnpublishConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: { xs: "1.2rem", sm: "1.5rem" },
        }}
      >
        Unpublish Scorecard?
      </DialogTitle>

      <DialogContent sx={{ padding: { xs: "16px", sm: "20px 24px" }, textAlign: "center" }}>
        Are you sure you want to unpublish the scorecard and edit it?
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          padding: { xs: "12px", sm: "16px 24px" },
          flexDirection: { xs: "column", sm: "row" },
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          color="secondary"
          sx={{ borderRadius: "8px", width: { xs: "100%", sm: "auto" } }}
        >
          Cancel
        </Button>

        <Button
          onClick={onConfirm}
          color="primary"
          sx={{
            borderRadius: "8px",
            width: { xs: "100%", sm: "auto" },
            "&:hover": { backgroundColor: "blue", color: "#fff" },
          }}
        >
          Unpublish
        </Button>
      </DialogActions>
    </Dialog>
  );
};

UnpublishConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired, // Dialog visibility state
  onClose: PropTypes.func.isRequired, // Function to close the dialog
  onConfirm: PropTypes.func.isRequired, // Function triggered on confirmation
};

export default UnpublishConfirmationDialog;
